module.exports = __webpack_public_path__ + "static/elpasocountyhealth-93ddc9c8f9c249d3bb4aa39de047ea44.png";